import React, { useState, useContext } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  // TextField,
  Typography,
  Box,
  // Chip,
} from "@mui/material";
import { ReportContext } from "../../ReportContext";
import Swal from "sweetalert2";
import ReadOnlyEditor from "../../../components/tiptap-templates/simple/read-only-editor";
import SimpleTiptapEditor from "../../../components/tiptap-templates/simple/custom-editor";

const ReviseProposal = ({
  solutionId,
  reload,
  setReload,
  proposal_notes,
  revision_notes,
}) => {
  const { reviseProposal } = useContext(ReportContext);
  const [open, setOpen] = useState(false);
  const [proposal, setProposal] = useState(
    sessionStorage.getItem(`revised_proposal_${solutionId}`) ||
      proposal_notes ||
      ""
  );
  const [loading, setLoading] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleChange = (htmlContent) => {
    setProposal(htmlContent);
    sessionStorage.setItem(`revised_proposal_${solutionId}`, htmlContent);
  };

  const handleSubmit = async () => {
    // console.log("Trigger submit")
    if (!proposal.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Proposal cannot be empty",
        confirmButtonColor: "#f44336",
      });
      return;
    }

    setLoading(true);
    const response = await reviseProposal({
      solution_id: solutionId,
      notes: proposal,
    });

    if (response?.status === "success") {
      sessionStorage.removeItem(`revised_proposal_${solutionId}`);

      await Swal.fire({
        icon: "success",
        title: "Proposal Resubmitted",
        text: "Your updated proposal has been saved.",
        confirmButtonColor: "#4CAF50",
      });

      if (setReload) setReload(!reload);
      handleClose();
    }
    setLoading(false);
  };

  return (
    <>
      {/* Trigger Button */}
      <Button
        variant="contained"
        color="info"
        onClick={handleOpen}
        sx={{ textTransform: "none", fontWeight: 600 }}
      >
        Revise Proposal
      </Button>

      {/* Dialog */}
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="md"
        PaperProps={{
          sx: {
            borderRadius: 3,
            overflow: "hidden",
            zIndex: 1600, // ensures above other dialogs
          },
        }}
        sx={{
          "& .MuiBackdrop-root": {
            zIndex: 1599, // backdrop also raised
          },
        }}
      >
        <DialogTitle sx={{ fontWeight: "bold", color: "info.main" }}>
          Revise Proposal
        </DialogTitle>

        <DialogContent dividers sx={{ bgcolor: "#fafafa" }}>
          <Box
            sx={{
              mb: 2,
              p: 2,
              borderLeft: "4px solid #ffc107",
              bgcolor: "#fff7e6",
            }}
          >
            <Typography variant="subtitle2" fontWeight={600}>
              Revision Notes
            </Typography>
            <Box sx={{ width: "100%", height: "100%", bgcolor: "white", borderRadius: 2, p: 2, boxShadow: 1 }}>
              <ReadOnlyEditor content={revision_notes || "No revision notes provided."} />
            </Box>
            {/* <Typography
              variant="body2"
              sx={{ whiteSpace: "pre-wrap", mt: 1 }}
              color="text.secondary"
            >
              {revision_notes || "No revision notes provided."}
            </Typography> */}
          </Box>

          {/* <TextField
            label="Updated Proposal"
            multiline
            fullWidth
            minRows={8}
            value={proposal}
            onChange={handleChange}
            placeholder="Type your revised proposal here..."
            variant="outlined"
          /> */}

            <Typography variant="subtitle2" fontWeight={600}>
              Updated Proposal
            </Typography>

          <Box
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: 2,
              overflow: "hidden",
              background: "#fff",
              transition: "all 0.3s ease",
              "&:hover": {
                // borderColor: "#10b981",
                boxShadow: "0 0 0 2px rgba(16, 185, 129, 0.1)",
              },
            }}
          >
            <SimpleTiptapEditor
              setContent={handleChange}
              initialContent={proposal || "<p>Type your revised proposal here...</p>"}
              navbarHeight={60}
              debounceDelay={500}
            />
          </Box>
        </DialogContent>

        <DialogActions sx={{ p: 2.5 }}>
          <Button onClick={handleClose} color="inherit" disabled={loading}>
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            color="success"
            variant="contained"
            disabled={loading}
          >
            {loading ? "Submitting..." : "Submit"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ReviseProposal;
